{
  "comment": "crunched 'GobTemplates.ini' from game/htdata832.pdb, ordered sections/props (extract-ini.mjs)",
  "sections": [
    {
      "name": "1",
      "props": [
        { "key": "Name", "value": "Guard" },
        { "key": "LongName", "value": "Security Guard" },
        { "key": "Cost", "value": "150" },
        { "key": "CostMP", "value": "100" },
        { "key": "MoveRate", "value": "18" },
        { "key": "ArmorStrength", "value": "39" },
        { "key": "InfantryDamage", "value": "9" },
        { "key": "InfantryDamageMP", "value": "12" },
        { "key": "VehicleDamage", "value": "3" },
        { "key": "StructureDamage", "value": "3" },
        { "key": "FiringRate", "value": "750" },
        { "key": "FiringRange", "value": "2" },
        { "key": "TimeToBuild", "value": "16" },
        { "key": "TimeToBuildMP", "value": "10" },
        { "key": "UIBoundsLeft", "value": "-6" },
        { "key": "UIBoundsTop", "value": "-7" },
        { "key": "UIBoundsRight", "value": "7" },
        { "key": "UIBoundsBottom", "value": "7" },
        { "key": "SortOffset", "value": "5" },
        { "key": "Animation", "value": "sri.anir" },
        {
          "key": "Description",
          "value": "Cheap and cheerful. Limited firepower and defensive capability."
        }
      ]
    },
    {
      "name": "2",
      "props": [
        { "key": "Name", "value": "Trooper" },
        { "key": "LongName", "value": "Rocket Trooper" },
        { "key": "Cost", "value": "300" },
        { "key": "MoveRate", "value": "11" },
        { "key": "ArmorStrength", "value": "50" },
        { "key": "InfantryDamage", "value": "6" },
        { "key": "VehicleDamage", "value": "17" },
        { "key": "StructureDamage", "value": "6" },
        { "key": "FiringRate", "value": "1600" },
        { "key": "FiringRange", "value": "3" },
        { "key": "TimeToBuild", "value": "16" },
        { "key": "UIBoundsLeft", "value": "-6" },
        { "key": "UIBoundsTop", "value": "-7" },
        { "key": "UIBoundsRight", "value": "7" },
        { "key": "UIBoundsBottom", "value": "7" },
        { "key": "SortOffset", "value": "5" },
        { "key": "Animation", "value": "lri.anir" },
        {
          "key": "Description",
          "value": "For those hard to reach places. Rockets are particularly effective against armored vehicles."
        }
      ]
    },
    {
      "name": "20",
      "props": [
        { "key": "Name", "value": "Raider" },
        { "key": "LongName", "value": "Corporate Raider" },
        { "key": "Cost", "value": "550" },
        { "key": "MoveRate", "value": "10" },
        { "key": "MoveRateMP", "value": "16" },
        { "key": "ArmorStrength", "value": "50" },
        { "key": "InfantryDamage", "value": "0" },
        { "key": "VehicleDamage", "value": "0" },
        { "key": "StructureDamage", "value": "16" },
        { "key": "FiringRate", "value": "1000" },
        { "key": "FiringRange", "value": "1" },
        { "key": "TimeToBuild", "value": "16" },
        { "key": "UIBoundsLeft", "value": "-6" },
        { "key": "UIBoundsTop", "value": "-7" },
        { "key": "UIBoundsRight", "value": "7" },
        { "key": "UIBoundsBottom", "value": "7" },
        { "key": "SortOffset", "value": "5" },
        { "key": "Animation", "value": "spi.anir" },
        {
          "key": "Description",
          "value": "Send the Raider to take over ememy buildings. Keep in mind he has no conventional weapons and little armor!"
        }
      ]
    },
    {
      "name": "34",
      "props": [
        { "key": "Name", "value": "Andy" },
        { "key": "LongName", "value": "Andy" },
        { "key": "Cost", "value": "550" },
        { "key": "MoveRate", "value": "22" },
        { "key": "ArmorStrength", "value": "100" },
        { "key": "InfantryDamage", "value": "56" },
        { "key": "VehicleDamage", "value": "24" },
        { "key": "StructureDamage", "value": "8" },
        { "key": "FiringRate", "value": "2300" },
        { "key": "FiringRange", "value": "4" },
        { "key": "TimeToBuild", "value": "16" },
        { "key": "UIBoundsLeft", "value": "-6" },
        { "key": "UIBoundsTop", "value": "-7" },
        { "key": "UIBoundsRight", "value": "7" },
        { "key": "UIBoundsBottom", "value": "7" },
        { "key": "SortOffset", "value": "5" },
        { "key": "Animation", "value": "andy.anir" },
        { "key": "Description", "value": "Long range scout and sniper" }
      ]
    },
    {
      "name": "37",
      "props": [
        { "key": "Name", "value": "Fox" },
        { "key": "LongName", "value": "Fox" },
        { "key": "Cost", "value": "550" },
        { "key": "MoveRate", "value": "18" },
        { "key": "ArmorStrength", "value": "80" },
        { "key": "InfantryDamage", "value": "56" },
        { "key": "VehicleDamage", "value": "24" },
        { "key": "StructureDamage", "value": "8" },
        { "key": "FiringRate", "value": "2300" },
        { "key": "FiringRange", "value": "4" },
        { "key": "TimeToBuild", "value": "16" },
        { "key": "UIBoundsLeft", "value": "-6" },
        { "key": "UIBoundsTop", "value": "-7" },
        { "key": "UIBoundsRight", "value": "7" },
        { "key": "UIBoundsBottom", "value": "7" },
        { "key": "SortOffset", "value": "5" },
        { "key": "Animation", "value": "andy.anir" },
        { "key": "Description", "value": "Bad guy" }
      ]
    },
    {
      "name": "18",
      "props": [
        { "key": "Name", "value": "Eagle" },
        { "key": "LongName", "value": "SR-98 Eagle" },
        { "key": "Cost", "value": "300" },
        { "key": "MoveRate", "value": "24" },
        { "key": "ArmorStrength", "value": "75" },
        { "key": "InfantryDamage", "value": "8" },
        { "key": "VehicleDamage", "value": "4" },
        { "key": "StructureDamage", "value": "4" },
        { "key": "FiringRate", "value": "1000" },
        { "key": "FiringRange", "value": "3" },
        { "key": "TimeToBuild", "value": "16" },
        { "key": "UIBoundsLeft", "value": "-10" },
        { "key": "UIBoundsTop", "value": "-10" },
        { "key": "UIBoundsRight", "value": "10" },
        { "key": "UIBoundsBottom", "value": "11" },
        { "key": "SortOffset", "value": "7" },
        { "key": "Animation", "value": "tmac.anir" },
        {
          "key": "Description",
          "value": "Fast but not particularly powerful or well armored. Makes a nice scout."
        }
      ]
    },
    {
      "name": "16",
      "props": [
        { "key": "Name", "value": "Broadsword" },
        { "key": "LongName", "value": "T-29 Broadsword" },
        { "key": "Cost", "value": "450" },
        { "key": "MoveRate", "value": "16" },
        { "key": "ArmorStrength", "value": "125" },
        { "key": "InfantryDamage", "value": "6" },
        { "key": "VehicleDamage", "value": "9" },
        { "key": "StructureDamage", "value": "15" },
        { "key": "FiringRate", "value": "1500" },
        { "key": "FiringRange", "value": "3" },
        { "key": "TimeToBuild", "value": "16" },
        { "key": "UIBoundsLeft", "value": "-10" },
        { "key": "UIBoundsTop", "value": "-10" },
        { "key": "UIBoundsRight", "value": "10" },
        { "key": "UIBoundsBottom", "value": "11" },
        { "key": "SortOffset", "value": "7" },
        { "key": "Animation", "value": "ltank.anir" },
        {
          "key": "Description",
          "value": "Equipped with a fine mortar cannon. Increased damage against buildings."
        }
      ]
    },
    {
      "name": "19",
      "props": [
        { "key": "Name", "value": "Hydra" },
        { "key": "LongName", "value": "M-18 Hydra" },
        { "key": "Cost", "value": "450" },
        { "key": "CostMP", "value": "550" },
        { "key": "MoveRate", "value": "14" },
        { "key": "ArmorStrength", "value": "100" },
        { "key": "ArmorStrengthMP", "value": "85" },
        { "key": "InfantryDamage", "value": "5" },
        { "key": "VehicleDamage", "value": "20" },
        { "key": "StructureDamage", "value": "8" },
        { "key": "FiringRate", "value": "1250" },
        { "key": "FiringRange", "value": "3" },
        { "key": "TimeToBuild", "value": "16" },
        { "key": "UIBoundsLeft", "value": "-10" },
        { "key": "UIBoundsTop", "value": "-10" },
        { "key": "UIBoundsRight", "value": "10" },
        { "key": "UIBoundsBottom", "value": "11" },
        { "key": "SortOffset", "value": "7" },
        { "key": "Animation", "value": "troc.anir" },
        {
          "key": "Description",
          "value": "Well armored and equipped with high-explosive rockets that really pack a punch against vehicles."
        }
      ]
    },
    {
      "name": "17",
      "props": [
        { "key": "Name", "value": "Liberator" },
        { "key": "LongName", "value": "T-33 Liberator" },
        { "key": "Cost", "value": "600" },
        { "key": "MoveRate", "value": "15" },
        { "key": "ArmorStrength", "value": "150" },
        { "key": "InfantryDamage", "value": "16" },
        { "key": "VehicleDamage", "value": "6" },
        { "key": "StructureDamage", "value": "4" },
        { "key": "FiringRate", "value": "1000" },
        { "key": "FiringRange", "value": "3" },
        { "key": "TimeToBuild", "value": "16" },
        { "key": "UIBoundsLeft", "value": "-10" },
        { "key": "UIBoundsTop", "value": "-10" },
        { "key": "UIBoundsRight", "value": "10" },
        { "key": "UIBoundsBottom", "value": "11" },
        { "key": "SortOffset", "value": "7" },
        { "key": "Animation", "value": "mtank.anir" },
        {
          "key": "Description",
          "value": "This tank's dual cannons fire fragmentation grenades that do serious damage to enemy infantry."
        }
      ]
    },
    {
      "name": "32",
      "props": [
        { "key": "Name", "value": "Cyclops" },
        { "key": "LongName", "value": "A-3 Cyclops" },
        { "key": "Cost", "value": "500" },
        { "key": "MoveRate", "value": "10" },
        { "key": "ArmorStrength", "value": "50" },
        { "key": "InfantryDamage", "value": "7" },
        { "key": "VehicleDamage", "value": "24" },
        { "key": "StructureDamage", "value": "48" },
        { "key": "FiringRate", "value": "3000" },
        { "key": "FiringRange", "value": "4" },
        { "key": "TimeToBuild", "value": "16" },
        { "key": "UIBoundsLeft", "value": "-12" },
        { "key": "UIBoundsTop", "value": "-12" },
        { "key": "UIBoundsRight", "value": "12" },
        { "key": "UIBoundsBottom", "value": "13" },
        { "key": "SortOffset", "value": "7" },
        { "key": "Animation", "value": "artillery.anir" },
        {
          "key": "Description",
          "value": "Long range of fire. Slow moving. Packs a punch but is not accurate against smaller units."
        }
      ]
    },
    {
      "name": "11",
      "props": [
        { "key": "Name", "value": "Bullpup" },
        { "key": "LongName", "value": "G-4 Bullpup" },
        { "key": "Cost", "value": "600" },
        { "key": "MoveRate", "value": "14" },
        { "key": "ArmorStrength", "value": "200" },
        { "key": "FiringRate", "value": "0" },
        { "key": "FiringRange", "value": "0" },
        { "key": "TimeToBuild", "value": "16" },
        { "key": "UIBoundsLeft", "value": "-10" },
        { "key": "UIBoundsTop", "value": "-10" },
        { "key": "UIBoundsRight", "value": "10" },
        { "key": "UIBoundsBottom", "value": "11" },
        { "key": "SortOffset", "value": "7" },
        { "key": "Animation", "value": "miner.anir" },
        { "key": "Menu", "value": "1032" },
        {
          "key": "Description",
          "value": "Increase your mining rate with additional Bullpups. It has no weapons but can take a lot of punishment."
        }
      ]
    },
    {
      "name": "22",
      "props": [
        { "key": "Name", "value": "Dominion" },
        { "key": "LongName", "value": "H-7 Dominion" },
        { "key": "Cost", "value": "1200" },
        { "key": "MoveRate", "value": "12" },
        { "key": "ArmorStrength", "value": "200" },
        { "key": "FiringRate", "value": "0" },
        { "key": "FiringRange", "value": "0" },
        { "key": "TimeToBuild", "value": "16" },
        { "key": "UIBoundsLeft", "value": "-10" },
        { "key": "UIBoundsTop", "value": "-10" },
        { "key": "UIBoundsRight", "value": "10" },
        { "key": "UIBoundsBottom", "value": "11" },
        { "key": "SortOffset", "value": "7" },
        { "key": "Animation", "value": "mobilehq.anir" },
        { "key": "Menu", "value": "1031" },
        {
          "key": "Description",
          "value": "Not happy where you are? Start a new base at a remote location with this Mobile Headquarters."
        }
      ]
    },
    {
      "name": "3",
      "props": [
        { "key": "Name", "value": "H.R.C." },
        { "key": "LongName", "value": "Human Resource Center (HRC)" },
        { "key": "TimeToBuild", "value": "15" },
        { "key": "Cost", "value": "1000" },
        { "key": "PowerDemand", "value": "10" },
        { "key": "ArmorStrength", "value": "250" },
        { "key": "UIBoundsLeft", "value": "-1" },
        { "key": "UIBoundsTop", "value": "-1" },
        { "key": "UIBoundsRight", "value": "49" },
        { "key": "UIBoundsBottom", "value": "33" },
        { "key": "SortOffset", "value": "29" },
        { "key": "Animation", "value": "HRC.anir" },
        { "key": "TileDimensions", "value": "3,2" },
        { "key": "ReserveDimensions", "value": "3,3" },
        { "key": "Menu", "value": "1008" },
        { "key": "BuildRate", "value": "2" },
        { "key": "UpgradeCost", "value": "750" },
        {
          "key": "Description",
          "value": "Use this building to recruit new personnel. Upgrade the HRC to gain access to more advanced units."
        }
      ]
    },
    {
      "name": "8",
      "props": [
        { "key": "Name", "value": "Processor" },
        { "key": "LongName", "value": "Galaxite Processor" },
        { "key": "TimeToBuild", "value": "15" },
        { "key": "Cost", "value": "1500" },
        { "key": "PowerDemand", "value": "10" },
        { "key": "ArmorStrength", "value": "350" },
        { "key": "UIBoundsLeft", "value": "0" },
        { "key": "UIBoundsTop", "value": "-1" },
        { "key": "UIBoundsRight", "value": "48" },
        { "key": "UIBoundsBottom", "value": "32" },
        { "key": "SortOffset", "value": "32" },
        { "key": "Animation", "value": "proc.anir" },
        { "key": "TileDimensions", "value": "3,2" },
        { "key": "ReserveDimensions", "value": "3,3" },
        {
          "key": "Description",
          "value": "Earth HQ provides credit for processed Galaxite. This building comes complete with one mining vehicle (Bullpup)! A Processor can store 3000 credits worth of Galaxite."
        }
      ]
    },
    {
      "name": "7",
      "props": [
        { "key": "Name", "value": "Generator" },
        { "key": "LongName", "value": "Power Generator" },
        { "key": "TimeToBuild", "value": "10" },
        { "key": "Cost", "value": "750" },
        { "key": "PowerSupply", "value": "40" },
        { "key": "ArmorStrength", "value": "200" },
        { "key": "UIBoundsLeft", "value": "1" },
        { "key": "UIBoundsTop", "value": "3" },
        { "key": "UIBoundsRight", "value": "33" },
        { "key": "UIBoundsBottom", "value": "31" },
        { "key": "SortOffset", "value": "30" },
        { "key": "Animation", "value": "Reactor.anir" },
        { "key": "TileDimensions", "value": "2,2" },
        {
          "key": "Description",
          "value": "Most buildings will not operate without sufficient power. Keep an eye on your power supply and demand at all times."
        }
      ]
    },
    {
      "name": "12",
      "props": [
        { "key": "Name", "value": "H.Q." },
        { "key": "LongName", "value": "Headquarters (HQ)" },
        { "key": "TimeToBuild", "value": "15" },
        { "key": "Cost", "value": "750" },
        { "key": "ArmorStrength", "value": "500" },
        { "key": "UIBoundsLeft", "value": "0" },
        { "key": "UIBoundsTop", "value": "0" },
        { "key": "UIBoundsRight", "value": "48" },
        { "key": "UIBoundsBottom", "value": "32" },
        { "key": "SortOffset", "value": "30" },
        { "key": "Animation", "value": "HQ.anir" },
        { "key": "TileDimensions", "value": "3,2" },
        { "key": "Menu", "value": "1016" },
        { "key": "BuildRate", "value": "100" }
      ]
    },
    {
      "name": "15",
      "props": [
        { "key": "Name", "value": "S.C." },
        { "key": "LongName", "value": "Surveillance Center (SC)" },
        { "key": "TimeToBuild", "value": "15" },
        { "key": "Cost", "value": "750" },
        { "key": "PowerDemand", "value": "15" },
        { "key": "ArmorStrength", "value": "250" },
        { "key": "UIBoundsLeft", "value": "-1" },
        { "key": "UIBoundsTop", "value": "-1" },
        { "key": "UIBoundsRight", "value": "33" },
        { "key": "UIBoundsBottom", "value": "33" },
        { "key": "SortOffset", "value": "30" },
        { "key": "Animation", "value": "Radar.anir" },
        { "key": "TileDimensions", "value": "2,2" },
        {
          "key": "Description",
          "value": "A Surveillance Center provides guidance control for Gun and Rocket Towers and is required to build them."
        }
      ]
    },
    {
      "name": "13",
      "props": [
        { "key": "Name", "value": "R&D Center" },
        { "key": "LongName", "value": "Research & Development Center" },
        { "key": "TimeToBuild", "value": "15" },
        { "key": "Cost", "value": "750" },
        { "key": "PowerDemand", "value": "15" },
        { "key": "ArmorStrength", "value": "250" },
        { "key": "UIBoundsLeft", "value": "-1" },
        { "key": "UIBoundsTop", "value": "-1" },
        { "key": "UIBoundsRight", "value": "33" },
        { "key": "UIBoundsBottom", "value": "33" },
        { "key": "SortOffset", "value": "30" },
        { "key": "Animation", "value": "Research.anir" },
        { "key": "TileDimensions", "value": "2,2" },
        { "key": "Menu", "value": "1012" },
        {
          "key": "Description",
          "value": "Invest in an R&D Center and its scientists will work hard to produce technological advances to aid you in your operations."
        }
      ]
    },
    {
      "name": "14",
      "props": [
        { "key": "Name", "value": "V.T.S." },
        { "key": "LongName", "value": "Vehicle Transport Station (VTS)" },
        { "key": "TimeToBuild", "value": "15" },
        { "key": "Cost", "value": "1250" },
        { "key": "CostMP", "value": "2000" },
        { "key": "PowerDemand", "value": "10" },
        { "key": "ArmorStrength", "value": "300" },
        { "key": "UIBoundsLeft", "value": "-1" },
        { "key": "UIBoundsTop", "value": "-1" },
        { "key": "UIBoundsRight", "value": "49" },
        { "key": "UIBoundsBottom", "value": "33" },
        { "key": "SortOffset", "value": "30" },
        { "key": "Animation", "value": "VTS.anir" },
        { "key": "TileDimensions", "value": "3,2" },
        { "key": "ReserveDimensions", "value": "3,3" },
        { "key": "Menu", "value": "1014" },
        { "key": "BuildRate", "value": "10" },
        { "key": "UpgradeCost", "value": "1000" },
        {
          "key": "Description",
          "value": "Use this building to order new vehicles. Upgrade the VTS to gain access to more advanced units."
        }
      ]
    },
    {
      "name": "21",
      "props": [
        { "key": "Name", "value": "Warehouse" },
        { "key": "LongName", "value": "Galaxite Storage Warehouse" },
        { "key": "TimeToBuild", "value": "15" },
        { "key": "Cost", "value": "750" },
        { "key": "PowerDemand", "value": "7" },
        { "key": "ArmorStrength", "value": "200" },
        { "key": "UIBoundsLeft", "value": "0" },
        { "key": "UIBoundsTop", "value": "0" },
        { "key": "UIBoundsRight", "value": "33" },
        { "key": "UIBoundsBottom", "value": "33" },
        { "key": "SortOffset", "value": "30" },
        { "key": "Animation", "value": "Warehouse.anir" },
        { "key": "TileDimensions", "value": "2,2" },
        {
          "key": "Description",
          "value": "Add Warehouses to increase processed Galaxite inventory capacity. Each Warehouse can store up to 5000 credits worth of Galaxite."
        }
      ]
    },
    {
      "name": "35",
      "props": [
        { "key": "Name", "value": "Replicator" },
        { "key": "LongName", "value": "Replicator" },
        { "key": "TimeToBuild", "value": "15" },
        { "key": "Cost", "value": "1000" },
        { "key": "PowerDemand", "value": "0" },
        { "key": "ArmorStrength", "value": "300" },
        { "key": "UIBoundsLeft", "value": "3" },
        { "key": "UIBoundsTop", "value": "0" },
        { "key": "UIBoundsRight", "value": "77" },
        { "key": "UIBoundsBottom", "value": "56" },
        { "key": "SortOffset", "value": "84" },
        { "key": "Animation", "value": "replicator.anir" },
        { "key": "TileDimensions", "value": "5,4" },
        { "key": "ReserveDimensions", "value": "5,4" },
        { "key": "BuildRate", "value": "2" },
        { "key": "UpgradeCost", "value": "400" },
        { "key": "Description", "value": "You're not supposed to be able to build this!" }
      ]
    },
    {
      "name": "26",
      "props": [
        { "key": "Name", "value": "Gatling" },
        { "key": "LongName", "value": "Gatling Tower" },
        { "key": "TimeToBuild", "value": "10" },
        { "key": "Cost", "value": "750" },
        { "key": "PowerDemand", "value": "10" },
        { "key": "ArmorStrength", "value": "150" },
        { "key": "InfantryDamage", "value": "16" },
        { "key": "VehicleDamage", "value": "5" },
        { "key": "StructureDamage", "value": "6" },
        { "key": "FiringRate", "value": "1333" },
        { "key": "FiringRange", "value": "3" },
        { "key": "UIBoundsLeft", "value": "0" },
        { "key": "UIBoundsTop", "value": "0" },
        { "key": "UIBoundsRight", "value": "16" },
        { "key": "UIBoundsBottom", "value": "16" },
        { "key": "SortOffset", "value": "30" },
        { "key": "Animation", "value": "mtower.anir" },
        { "key": "TileDimensions", "value": "1,1" },
        {
          "key": "Description",
          "value": "Defend your base from unwanted visits by the competition. Gatling Towers are particularly effective against troops. NOTE: a Surveillance Center is required to guide their automatic targeting systems."
        }
      ]
    },
    {
      "name": "27",
      "props": [
        { "key": "Name", "value": "Rocket Twr" },
        { "key": "LongName", "value": "Rocket Tower" },
        { "key": "TimeToBuild", "value": "10" },
        { "key": "Cost", "value": "850" },
        { "key": "PowerDemand", "value": "10" },
        { "key": "ArmorStrength", "value": "150" },
        { "key": "InfantryDamage", "value": "6" },
        { "key": "VehicleDamage", "value": "18" },
        { "key": "StructureDamage", "value": "6" },
        { "key": "FiringRate", "value": "1500" },
        { "key": "FiringRange", "value": "3" },
        { "key": "UIBoundsLeft", "value": "0" },
        { "key": "UIBoundsTop", "value": "0" },
        { "key": "UIBoundsRight", "value": "16" },
        { "key": "UIBoundsBottom", "value": "16" },
        { "key": "SortOffset", "value": "30" },
        { "key": "Animation", "value": "rtower.anir" },
        { "key": "TileDimensions", "value": "1,1" },
        {
          "key": "Description",
          "value": "Rocket Towers are particularly effective against armored vehicles. NOTE: a Surveillance Center is required to guide their automatic targeting systems."
        }
      ]
    }
  ]
}
